module.exports = __webpack_public_path__ + "media/img/frontend_application/reward-icon-lg-d4db84361438f663e9083f12ccce8c66.png";